import React, {Fragment,useContext,useState} from "react";
import axios from "services/interceptor/Interceptor";
import FormSection from "components/sales/formSection/formSection";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import {Button} from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import {BaseUrl} from "contexts/baseUrl/baseUrl";
import Config from "services/config/config";
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./modify.css";

const EditCreditPopup = ({
  showEditCreditPopup,
  creditLimit,
  creditRemaining,
  creditExhausted,
  departmentName,
  monthlyAverageRevenue,
  type,
  departmentId,
  userId,
  userName,
  responsibleEmail,
  responsibleDepartment,
  teamId,
  teamName,
  expectedCreditLimit,
  onClosePopup = () => {},
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [newCreditLimit, setNewCreditLimit] = useState(0);

  async function submit() {

    setIsLoading(true);
    setDisableSubmit(true);

    if(newCreditLimit == ''){
      toast.error("New credit limit is missing");
      setDisableSubmit(false);
      return false;
    }

    if(parseFloat(newCreditLimit)<parseFloat(creditExhausted)){
      toast.error("Credit limit cannot be less than the outstanding amount: "+ creditExhausted);
      onClosePopup();
      setDisableSubmit(false);
      return false;
    }

    let data = null;

    if(type=='D'){

      const businessPayload = {
        type: 'SELF',
        amount: newCreditLimit,
        department_id:departmentId,
        team_id: teamId
      };

      let url = Config.creditPolicy.updateBusinessCredits;
      const response = await axios.post(url, businessPayload);
      data = response.data;

    }
    else if(type=='E'){

      const employeePayload = {
        type: 'SELF',
        amount: newCreditLimit,
        responsible_email:responsibleEmail,
        responsible_department:responsibleDepartment,
        responsible_team: teamName
      };

      // console.log(employeePayload); return false;

      let url = Config.creditPolicy.updateEmployeeCredits;
      const response = await axios.post(url, employeePayload);
      data = response.data;

    }
    else {
      return false;
    }

    onClosePopup();

    if (data.response.status != 200) {
      if (data?.response?.message) {
        setIsLoading(false);
        toast.error(data.message);
        setTimeout(() => {
          window.location.reload();
        }, 300);
      } else {
        setIsLoading(false);
        toast.error("Some error occurred!");
        setDisableSubmit(false);
      }
    } else {
      setIsLoading(false);
      toast.success("Credit Limit Updated Successfully");
      setDisableSubmit(false);
      setTimeout(() => {
        window.location.reload();
      }, 300);
    }

  }

  const creditData = () => {
    return (
        <div className="card">
          <div className="card-body">
            <h5 className="mb-6 text-primary">Credit Details</h5>

            <div className="row mb-4">
              <div className="col-md-6 mb-4">
                <p><strong>Department:</strong> {departmentName}</p>
                <p className="mt-3"><strong>Current Credit Limit:</strong> Rs {creditLimit}</p>
                {type === 'D' && (
                  <p className="mt-3"><strong>Expected Credit Limit:</strong> Rs {expectedCreditLimit}</p>
                )}
                {type === 'E' && (
                  <p className="mt-3"><strong>Employee Name:</strong> {userName}</p>
                )}
                {type === 'E' && (
                  <p className="mt-3"><strong>Team Name:</strong> {teamName}</p>
                )}
              </div>
              <div className="col-md-6 mb-4">
                <p><strong>Monthly Average Revenue:</strong> Rs {monthlyAverageRevenue}</p>
                <p className="mt-3"><strong>Outstanding:</strong> Rs {creditExhausted}</p>
                <p className="mt-3"><strong>Credit Remaining:</strong> Rs {creditRemaining}</p>
              </div>
            </div>

            <div className="row mb-3">

              <div className="col-md-4 offset-md-1 mb-3">
                <ConstantInput
                  label="New Credit Limit"
                  type="number"
                  required
                  handleChange={(val) => {
                    setNewCreditLimit(val);
                  }}
                  isStarRequired={true}
                />
              </div>

              <div className="col-md-6 mb-6 text-end">
                <Button
                  className="button-left btn btn-sm"
                  onClick={submit}
                  disabled={disableSubmit}
                >
                  Edit Credit Limit
                </Button>
              </div>
            </div>
  
          </div>
        </div>
    );
  };  
   
  return (
    <>
      <ModalPop
        title={"Edit Credit Limit"}
        show={showEditCreditPopup}
        handleModalHide={() => {
          onClosePopup();
        }}
      >
        <Fragment>
          <div
            className="tab-pane fade show active"
            id="edit-profile"
            role="tabpanel"
            aria-labelledby="edit-profile-tab"
          >
            <FormSection>{creditData()}</FormSection>
          </div>
          <div
            className="tab-pane fade"
            id="emails"
            role="tabpanel"
            aria-labelledby="emails-tab"
          >
          </div>
        </Fragment>
      </ModalPop>
    </>
  );
};

export default EditCreditPopup;
